import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import DataGrid from '../../Components/DataGrid';
import Loading from '../../Components/Loading';
import EmptyVisualization from '../../Components/EmptyVisualization';

const TableWrapper = ({ data, viewDetail }) => (
  <DataGrid
    data={data}
    columnHeaders='eventHeaders'
    getTdProps={(state, rowInfo) => ({
      onClick: (e, handleOriginal) => {
        viewDetail(rowInfo.original);
        if (handleOriginal) {
          handleOriginal();
        }
      },
      style: {
        cursor: 'pointer',
      },
    })}
    columns={[{
      accessor: 'created',
      Cell: p => moment(p.value).format('MM/DD/YYYY'),
    }, {
      accessor: 'name',
    }, {
      accessor: 'priority',
    }, {
      accessor: 'status',
    }]}
    showPagination={false}
  />
);

TableWrapper.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  viewDetail: PropTypes.func.isRequired,
};

const StatesTable = ({ tableData, viewDetail, handleRetry }) => {
  const tableIsLoading = tableData.loading || !tableData.firstLoadComplete;
  const tableIsEmpty = !tableData.loading && tableData.dataIsEmpty;
  const tableHasError = !!tableData.error;

  return (
    <React.Fragment>
      { tableIsLoading &&
        <Loading />
      }

      { (tableIsEmpty || tableHasError) &&
        <div>
          <EmptyVisualization
            isError={tableHasError}
            handleRetry={handleRetry}
          >
            <TableWrapper
              data={tableData.visualizationData}
              viewDetail={viewDetail}
            />
          </EmptyVisualization>
        </div>
      }

      { !tableIsLoading && !tableIsEmpty && !tableHasError &&
        <TableWrapper
          data={tableData.visualizationData}
          viewDetail={viewDetail}
        />
      }
    </React.Fragment>
  );
};

StatesTable.propTypes = {
  tableData: PropTypes.shape({}).isRequired,
  viewDetail: PropTypes.func,
  handleRetry: PropTypes.func.isRequired,
};

StatesTable.defaultProps = {
  viewDetail: () => {},
};

export default StatesTable;



// WEBPACK FOOTER //
// ./src/views/Pages/Dashboard/StatesTable.js